<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
   
    <!-- 头部背景 -->
    <div class="top_bg">
    </div>
    <div class="container_box">
      <div style="width: 246px;">
        <div class="top_img">
          <img src="../../static/img/channels/add.png" alt="" class="top_imgs">
        </div>
        <div class="top_index">获客拉新</div>
        <div class="top_detail">
          多人拼团、销售员、瓜<br>分劵、团购返现
        </div>
      </div>
      <div style="width: 246px;">
        <div class="top_img">
          <img src="../../static/img/channels/addone.png" alt="" class="top_imgs">
        </div>
        <div class="top_index">下单转化</div>
        <div class="top_detail">
          限时折扣、优惠券、<br>秒杀、砍价
        </div>
      </div>
      <div style="width: 246px;">
        <div class="top_img">
          <img src="../../static/img/channels/addtwo.png" alt="" class="top_imgs">
        </div>
        <div class="top_index">提高客单</div>
        <div class="top_detail">
          打包一口价、优惠<br>套餐、满减送
        </div>
      </div>
      <div style="width: 246px;">
        <div class="top_img">
          <img src="../../static/img/channels/addthree.png" alt="" class="top_imgs">
        </div>
        <div class="top_index">留存复购</div>
        <div class="top_detail">
          积分商城、会员储值<br>、会员卡、签到
        </div>
      </div>
    </div>
    <!-- 合伙人六大优势 -->
    <div style="margin: 0 auto;width: 1200px;padding-top: 83px;">
      <div style="display: flex;align-items: center;">
        <div>
          <div class="name">ZHAOMEIW</div>
          <div class="appiont">合伙人六大优势</div>
        </div>
        <div style="width: 694px;height: 1px;background: #D8E1E0"></div>
      </div>
      <div style="display: flex;align-items: center;margin-top: 42px;">
        <div class="box">
          <div class="boxbefore">
            <div class="box_img">
              <img src="../../static/img/channels/pit.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="boxtitle">自用省钱、分享赚钱</div>
            <div class="boxtext">合作送等价值的店务系统，续费可享受5折优惠，分享即可获取丰厚奖金</div>
          </div>
          <div class="boxhover">
            <div class="boxhover_movie">
              <div class="box_img">
                <img src="../../static/img/channels/pit2.png" alt="" style="width: 100%;height: 100%;">
              </div>
              <div class="boxtitle" style="color: #fff;">自用省钱、分享赚钱</div>
              <div class="boxtext" style="color: #fff;">合作送等价值的店务系统，续费可享受5折优惠，分享即可获取丰厚奖金</div>
            </div>
          </div>
        </div>
        <div class="box1">
          <div class="boxbefore">
            <div class="box_img">
              <img src="../../static/img/channels/danger.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="boxtitle">低风险、高回报</div>
            <div class="boxtext">可享受多级别合作奖励、返利政策，保证利润空间，实现低投入高回报</div>
          </div>
          <div class="boxhover1">
            <div class="boxhover_movie">
              <div class="box_img">
                <img src="../../static/img/channels/danger2.png" alt="" style="width: 100%;height: 100%;">
              </div>
              <div class="boxtitle" style="color: #fff;">低风险、高回报</div>
              <div class="boxtext" style="color: #fff;">可享受多级别合作奖励、返利政策，保证利润空间，实现低投入高回报</div>
            </div>
          </div>
        </div>
        <div class="box2">
          <div class="boxbefore">
            <div class="box_img">
              <img src="../../static/img/channels/team.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="boxtitle">专业团队、值得信赖</div>
            <div class="boxtext">近7年研发创新经验、近20年美业实战经验、合作近10000家美容院</div>
          </div>
          <div class="boxhover2">
            <div class="boxhover_movie">
              <div class="box_img">
                <img src="../../static/img/channels/team2.png" alt="" style="width: 100%;height: 100%;">
              </div>
              <div class="boxtitle" style="color: #fff;">专业团队、值得信赖</div>
              <div class="boxtext" style="color: #fff;">近7年研发创新经验、近20年美业实战经验、合作近10000家美容院</div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;align-items: center;">
        <div class="box3">
          <div class="boxbefore">
            <div class="box_img">
              <img src="../../static/img/channels/train.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="boxtitle">全面培训</div>
            <div class="boxtext">现场教学指导、远程指引教导、专属客服培训，帮助合伙人轻松谈合作，提高业务能力</div>
          </div>
          <div class="boxhover3">
            <div class="boxhover_movie">
              <div class="box_img">
                <img src="../../static/img/channels/train2.png" alt="" style="width: 100%;height: 100%;">
              </div>
              <div class="boxtitle" style="color: #fff;">全面培训</div>
              <div class="boxtext" style="color: #fff;">现场教学指导、远程指引教导、专属客服培训，帮助合伙人轻松谈合作，提高业务能力</div>
            </div>
          </div>
        </div>
        <div class="box4">
          <div class="boxbefore">
            <div class="box_img">
              <img src="../../static/img/channels/teach.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="boxtitle">技术指导</div>
            <div class="boxtext">专属一对一服务，实现7x24小时全方位指导、提供专业、高效的技术支持，推动合作进度</div>
          </div>
          <div class="boxhover4">
            <div class="boxhover_movie">
              <div class="box_img">
                <img src="../../static/img/channels/teach2.png" alt="" style="width: 100%;height: 100%;">
              </div>
              <div class="boxtitle" style="color: #fff;">技术指导</div>
              <div class="boxtext" style="color: #fff;">专属一对一服务，实现7x24小时全方位指导、提供专业、高效的技术支持，推动合作进度</div>
            </div>
          </div>
        </div>
        <div class="box5">
          <div class="boxbefore">
            <div class="box_img">
              <img src="../../static/img/channels/brand.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <div class="boxtitle">品牌保障</div>
            <div class="boxtext">拥有落地的美业SaaS云服务系统，专业的美业产业链综合性平台，促进合作人员推广宣传</div>
          </div>
          <div class="boxhover5">
            <div class="boxhover_movie">
              <div class="box_img">
                <img src="../../static/img/channels/brand2.png" alt="" style="width: 100%;height: 100%;">
              </div>
              <div class="boxtitle" style="color: #fff;">品牌保障</div>
              <div class="boxtext" style="color: #fff;">拥有落地的美业SaaS云服务系统，专业的美业产业链综合性平台，促进合作人员推广宣传</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 合伙人资格 -->
    <div class="temp">
      <div style="font-size:28px;color: #000;text-align: center;padding-top: 94px">
        合伙人资格
      </div>
      <div style="font-size: 18px;color: #2B2B2B;text-align: center;margin-top: 10px">
        期待您的加入
      </div>
      <div style="display: flex;align-items: center;margin-top: 25px;width: 1200px;margin: 0 auto;justify-content: space-between;">
        <div style="text-align: center;">
          <div class="goods_img"><img src="../../static/img/channels/resources.png" alt=""></div>
          <div class="goods_title">优质的客户资源</div>
          <div class="goods_text">拥有优质的美业资源或从事美业 相关领域者或连锁体系</div>
        </div>
        <div style="text-align: center;">
          <div class="goods_img"><img src="../../static/img/channels/quality.png" alt=""></div>
          <div class="goods_title">良好的公司资质</div>
          <div class="goods_text">具备合法营业执照或独立法人代 表，良好的信誉和口碑</div>
        </div>
        <div style="text-align: center;">
          <div class="goods_img"><img src="../../static/img/channels/sales.png" alt=""></div>
          <div class="goods_title"> 专业的销售团队</div>
          <div class="goods_text">具有互联网或SaaS领域的代理或 销售经营背景的团队</div>
        </div>
      </div>
    </div>
    <!-- 合作流程 -->
    <div style="width: 100%;margin-bottom: 50px;">
      <div style="display: flex;align-items: center;width: 1200px;margin:0  auto;padding-top: 92px;">
        <div>
          <div class="name">ZHAOMEIW</div>
          <div class="appiont">合作流程</div>
        </div>
        <div style="width: 694px;height: 1px;background: #D8E1E0">
        </div>
      </div>
      <!-- 流程图 -->
      <div style="width: 1200px;height: 500px;margin:0 auto;position: relative;margin-top: 50px;">
        <img src="../../static/img/channels/square.png" alt="" style="width: 1200px;height: 258px;margin-top: 59px;">
        <div class="img1">
          <div style="font-size: 20px;margin-top: 140px;margin-left: 30px;color: #343434;">合作申请</div>
        </div>
        <div class="img2">
          <div style="font-size: 20px;margin-top: 140px;margin-left: 30px;color: #343434;">资质审核</div>
        </div>
        <div class="img3">
          <div style="font-size: 20px;margin-top: 140px;margin-left: 30px;color: #343434;">合作洽谈</div>
        </div>
        <div class="img4">
          <div style="font-size: 20px;margin-top: 140px;margin-left: 30px;color: #343434;">签约合同</div>
        </div>
        <div class="img5">
          <div style="font-size: 20px;margin-top: 140px;margin-left: 30px;color: #343434;">培训指导</div>
        </div>
        <div class="img6">
          <div style="font-size: 20px;margin-top: 140px;margin-left: 30px;color: #343434;">拓展业务</div>
        </div>
      </div>
      <div style="margin: 0 auto;width: 1200px;">
        <el-button type="primary" style="width: 800px;margin-left: 200px;height: 50px;" @click="apply">立即申请</el-button>
      </div>
      
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
   
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        scroll: '',
        scroll100: true,
        scroll700: false
      };
    },
    watch: {
      scroll: function () {      
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push('/')
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push('./home')
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push('./supplyChain')
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push('./marketingTools')
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push('./company')
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push('./channels')
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push('./contact')
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push('./culture')
      },
      //找美商学院-商学院文化
      goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
        this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      apply() {

      },
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() {

    },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])

    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";
  @import "../assets/css/mains.css";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
  }

  .top_bg {
    background-image: url('../../static/img/channels/bigname2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 824px;
    position: relative;
    top: 0;
    left: 0;
  }

  .container_box {
    width: 1200px;
    height: 256px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-image: url('../../static/img/channels/22.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .top_img {
    width: 52px;
    height: 52px;
    margin: 0 auto;
    /* background: orange; */
  }

  .top_imgs {
    width: 100%;
    height: 100%;
  }

  .top_index {
    font-size: 18px;
    color: #000;
    margin: 36px 39px;
    text-align: center;
  }

  .top_detail {
    font-size: 14px;
    color: #575B5A;
    margin-top: 18px;
    line-height: 20px;
    letter-spacing: 1px;
    width: 246px;
    text-align: center;
  }

  .name {
    font-size: 36px;
    color: #343434;
    line-height: 54px;
    letter-spacing: 3px;
  }

  .appiont {
    font-size: 26px;
    color: #343434;
    line-height: 37px;
    letter-spacing: 2px;
    margin-top: 11px;
  }

  .box {
    width: 387px;
    height: 266px;
    position: relative;
    overflow: hidden;
    margin-right: 18px;
    margin-bottom: 16px;
  }
  .box1 {
    width: 387px;
    height: 266px;
    position: relative;
    overflow: hidden;
    margin-right: 18px;
    margin-bottom: 16px;
  }
  .box2 {
    width: 387px;
    height: 266px;
    position: relative;
    overflow: hidden;
    margin-right: 18px;
    margin-bottom: 16px;
  }
  .box3 {
    width: 387px;
    height: 266px;
    position: relative;
    overflow: hidden;
    margin-right: 18px;
    margin-bottom: 16px;
  }
  .box4 {
    width: 387px;
    height: 266px;
    position: relative;
    overflow: hidden;
    margin-right: 18px;
    margin-bottom: 16px;
  }
  .box5 {
    width: 387px;
    height: 266px;
    position: relative;
    overflow: hidden;
    margin-right: 18px;
    margin-bottom: 16px;
  }
  .boxbefore {
    width: 387px;
    height: 266px;
    background: rgba(249, 249, 249, 1);
    position: absolute;
    top: 0;
    left: 0;
    opacity: 1;
  }

  .box_img {
    width: 70px;
    height: 70px;
    margin: 0 auto;
    padding-top: 20px;
  }

  .boxtitle {
    font-size: 19px;
    font-weight: 800;
    color: #070707;
    text-align: center;
    margin-top: 20px;
  }

  .boxtext {
    font-size: 14px;
    color: #333333;
    text-align: center;
    line-height: 20px;
    letter-spacing: 1px;
    width: 262px;
    margin-top: 23px;
    margin-left: 63px;
    /* margin: 23px 62px 57px 63px; */
  }

  .boxhover {
    width: 387px;
    height: 266px;
    background-image: url('../../static/img/channels/1.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 387px 266px;
    transition: all 0.2s;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  .boxhover1 {
    width: 387px;
    height: 266px;
    background-image: url('../../static/img/channels/2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 387px 266px;
    transition: all 0.2s;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  .boxhover2 {
    width: 387px;
    height: 266px;
    background-image: url('../../static/img/channels/3.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 387px 266px;
    transition: all 0.2s;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  .boxhover3 {
    width: 387px;
    height: 266px;
    background-image: url('../../static/img/channels/4.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 387px 266px;
    transition: all 0.2s;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  .boxhover4 {
    width: 387px;
    height: 266px;
    background-image: url('../../static/img/channels/5.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 387px 266px;
    transition: all 0.2s;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  .boxhover5 {
    width: 387px;
    height: 266px;
    background-image: url('../../static/img/channels/6.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 387px 266px;
    transition: all 0.2s;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  .boxhover_movie {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.59);
    ;
  }

  .box:hover {
    margin-top: -10px;
    background-image: url('../../static/img/channels/1.png');
    transition: all 0.2s;
  }
  .box1:hover {
    margin-top: -10px;
    background-image: url('../../static/img/channels/2.png');
    transition: all 0.2s;
  }
  .box2:hover {
    margin-top: -10px;
    background-image: url('../../static/img/channels/3.png');
    transition: all 0.2s;
  }
  .box3:hover {
    margin-top: -10px;
    background-image: url('../../static/img/channels/4.png');
    transition: all 0.2s;
  }
  .box4:hover {
    margin-top: -10px;
    background-image: url('../../static/img/channels/5.png');
    transition: all 0.2s;
  }
  .box5:hover {
    margin-top: -10px;
    background-image: url('../../static/img/channels/6.png');
    transition: all 0.2s;
  }
  .boxbefore:hover {
    opacity: 0;
  }

  .boxhover:hover {
    opacity: 1;
  }
  .boxhover1:hover {
    opacity: 1;
  }
  .boxhover2:hover {
    opacity: 1;
  }
  .boxhover3:hover {
    opacity: 1;
  }
  .boxhover4:hover {
    opacity: 1;
  }
  .boxhover5:hover {
    opacity: 1;
  }
  
  .temp {
    background-image: url('../../static/img/big.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 485px;
    margin-top: 39px;
  }

  .goods_img {
    width: 112px;
    height: 112px;
    margin-left: 42px;
  }

  .goods_img img {
    width: 100%;
    height: 100%;
  }

  .goods_title {
    font-size: 20px;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 28px;
    margin-top: 24px;
    font-family:PingFangSC-Medium,PingFang SC;
  }

  .goods_text {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-top: 20px;
    width: 196px;
    height: 40px;
  }

  .img1 {
    background-image: url('../../static/img/channels/apply2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 138px;
    height: 138px;
    position: absolute;
    top: 0;
    left: 138px;
  }

  .img1:hover {
    background-image: url('../../static/img/channels/apply.png');
  }

  .img2 {
    background-image: url('../../static/img/channels/audit2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 138px;
    height: 138px;
    position: absolute;
    top: 0;
    left: 526px
  }

  .img2:hover {
    background-image: url('../../static/img/channels/audit.png');
  }

  .img3 {
    background-image: url('../../static/img/channels/copertion2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 138px;
    height: 138px;
    position: absolute;
    top: 0;
    /* right: 161px; */
    left: 888px;
  }

  .img3:hover {
    background-image: url('../../static/img/channels/copertion.png');
  }

  .img4 {
    background-image: url('../../static/img/channels/sign2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 138px;
    height: 138px;
    position: absolute;
    top: 220px;
    left: 138px;
  }

  .img4:hover {
    background-image: url('../../static/img/channels/sign.png');
  }

  .img5 {
    background-image: url('../../static/img/channels/guide2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 138px;
    height: 138px;
    position: absolute;
    top: 220px;
    left: 526px
  }

  .img5:hover {
    background-image: url('../../static/img/channels/guide.png');
  }

  .img6 {
    background-image: url('../../static/img/channels/expand2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 138px;
    height: 138px;
    position: absolute;
    top: 220px;
    left: 888px;
    /* right: 161px; */
  }

  .img6:hover {
    background-image: url('../../static/img/channels/expand.png');
  }
</style>


// WEBPACK FOOTER //
// src/page/channels.vue